export default __webpack_public_path__ + "assets/5cb3460e95e9ca881a5eb9b8bf9c1225/04.jpg";